import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Title } from '@angular/platform-browser';

import { SidebarMenuService } from '../sidebar-menu/sidebar-menu.service';

/**
 * A placeholder for a service that supplies info about the page and the site.
 */
@Injectable({
  providedIn: 'root'
})
export class PageTitleService {
  public siteName: string = 'Servicely';
  public pageTitle: string = this.siteName;

  constructor(
    private sidebarMenuService: SidebarMenuService,
    private titleService: Title,
    private router: Router,
  ) {}

  init() {
  }
}
